import { render, staticRenderFns } from "./quotationsInformation.vue?vue&type=template&id=188df21c&scoped=true&"
import script from "./quotationsInformation.vue?vue&type=script&lang=js&"
export * from "./quotationsInformation.vue?vue&type=script&lang=js&"
import style0 from "./quotationsInformation.vue?vue&type=style&index=0&id=188df21c&lang=scss&scoped=true&"
import style1 from "./quotationsInformation.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188df21c",
  null
  
)

export default component.exports